


























import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ReservationCandidateList } from '@/api'
import { SortOrder } from '@/types'
import { orderBy } from 'lodash'
import {
  DataTable,
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '50',
    resizable: true,
    items: [
      {
        name: 'name',
        headerText: '名称',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '50',
    resizable: true,
    items: [
      {
        name: 'nameKana',
        headerText: '名称（カナ）',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

export interface ReservationCandidateListSearchTableItem
  extends ReservationCandidateList {
  isSelected: boolean
}

@Component({
  components: { DataTable }
})
export default class ReservationCandidateListSearchTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: ReservationCandidateListSearchTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): ReservationCandidateListSearchTableItem[] {
    if (this.sortName) {
      return orderBy<ReservationCandidateListSearchTableItem>(
        this.items,
        (item: ReservationCandidateListSearchTableItem) =>
          item[this.sortName as keyof ReservationCandidateListSearchTableItem],
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  @Watch('items')
  onChangeItems(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  @Emit('click:row')
  onClickRow(index: number): number {
    return this.items.findIndex(item => item.id === this.sortedItems[index].id)
  }
}
